import React, { useEffect, useRef, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import PdfButton from "../../ui/pdf-button";
import Button from "../../ui/button";
import SecondaryLinks from "../../ui/secondary-links";
import Gallery from "../../gallery";
import ApplyNow from "../../ui/apply-now-button";
import ScheduleTour from "../../ui/schedule-button";
import {
  Wrapper,
  MenuWrap,
  Item,
  Li,
  Overlay,
  Primary,
  CloseButton,
  PortalLink,
  Line,
  WLogo,
  Btns,
  Center,
} from "./index.styled";
import useWindowSize from "../../../helpers/useWindowSize";

const Menu = () => {
  const {
    menuContent: { content: links },
  } = useStaticQuery(graphql`
    query MenuQuery {
      menuContent {
        content {
          primary {
            title
            url
          }
        }
      }
    }
  `);
  const menuRef = useRef(null);
  const { isMobile } = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const [openGallery, setOpenGallery] = useState(false);

  const onClose = () => {
    menuRef.current.classList.remove("open");
  };

  const onGallery = () => {
    setOpenGallery(true);
  };

  useEffect(() => {
    const menu = menuRef.current;
    if (!menu) return undefined;

    const syncOpenState = () => {
      setIsOpen(menu.classList.contains("open"));
    };

    syncOpenState();
    const observer = new MutationObserver(syncOpenState);
    observer.observe(menu, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return (
    <Wrapper id={"menu"} ref={menuRef} aria-hidden={!isOpen}>
      <MenuWrap id="site-navigation" as="nav" aria-label="Primary">
        <Line className={"top"}>
          <CloseButton
            type="button"
            onClick={onClose}
            aria-label="Close menu"
          />
          {/*  <PortalLink
            href="https://mapleterraceresidences.residentportal.com/auth"
            target={'_blank'}
          >
            Resident Portal
          </PortalLink> */}
        </Line>
        <Center>
          <Primary>
            {links.primary.map((item, index) => (
              <Li key={`primary-item-${index}`} onClick={onClose}>
                {item.title === "Schedule a Tour" ? (
                  <Item index={index} to={"#"} className={"hytour-link"}>
                    {item.title}
                  </Item>
                ) : (
                  <Item to={item.url} index={index}>
                    {item.title}
                  </Item>
                )}
              </Li>
            ))}
          </Primary>
          {/* <WLogo /> */}
          <Btns>
            <Button
              title={"Resident Portal"}
              className={"black"}
              as={"a"}
              target={"_blank"}
              href="https://mapleterraceresidences.residentportal.com/auth"
            />
            <PdfButton />
          </Btns>
        </Center>
        <Line className="col">
          <Line className="row">
            {/*  <ScheduleTour className={'webHide black'} />
            <ApplyNow className={['webHide black'].join(' ')} /> */}
          </Line>
          <SecondaryLinks onClose={onClose} menu />
        </Line>
      </MenuWrap>
      <Overlay onClick={onClose} />
      <Gallery open={openGallery} onClose={() => setOpenGallery(false)} />
    </Wrapper>
  );
};

export default Menu;
